import { render, staticRenderFns } from "./StampExchangeDetail.vue?vue&type=template&id=3c0d7a60&scoped=true&"
import script from "./StampExchangeDetail.vue?vue&type=script&lang=js&"
export * from "./StampExchangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./StampExchangeDetail.vue?vue&type=style&index=0&id=3c0d7a60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d7a60",
  null
  
)

export default component.exports